<template>
  <div class="borrower-container">
    <div class="route-name">{{ $t(`message.sideMenu.${this.$route.name}`) }}</div>
    <div class="user-info-container">
      <div class="user-status" :class="`${profile.status}-profile`">
        {{ $t(`message.profile.status.${profile.status}`) }}
      </div>
      <div class="user-info">
        <div class="user-name">
          {{ profile.name_ru.family_name_ru }}
          {{ profile.name_ru.given_name_ru }}
        </div>
      </div>
      <div class="rate-block">
        <span>{{ $t("message.profile.rate") }}</span>
        <div class="rate" v-if="profile.rating > 0">{{ profile.rating }}</div>
        <div class="no-rate-block" v-if="profile.rating === 0">
          <img src="../../../public/custom/images/attention.svg" alt="Attention image">
          <span>{{ $t('message.profile.borrower.noRate') }}</span>
        </div>
      </div>
      <!-- <div class="user-location">{{ userLocality }}</div> -->
      <div class="user-role">
        <span>{{ $t("message.profile.role.title") }}</span>
        &ensp;
        <span class="role">
          {{ $t(`message.profile.role.${this.profile.role}`) }}
        </span>
      </div>
    </div>
    <div class="no-scoring-agreement" v-if="profile.expiredPersonalDataProcessingAgreement">
      {{ $t('message.profile.borrower.noScoringAgreement.start') }}
      <router-link class="no-card-link" to="scoring-agreement">{{ $t('message.profile.borrower.noScoringAgreement.link') }}</router-link>
      {{ $t('message.profile.borrower.noScoringAgreement.end') }}
    </div>
    <div class="no-card-container no-scoring-agreement" v-if="!profile.default_card_id">
      <router-link class="no-card-link" to="cards">{{ $t('message.profile.borrower.noCardLink') }}</router-link>
      {{ $t('message.profile.borrower.noCardText') }}
    </div>
    <div class="active-offers-container">
      <div class="active-offers-title">
        {{ $t('message.profile.borrower.activeOffers.title') }}
      </div>
      <div class="offers-item-header" v-if="!isBorrowerLoansListEmpty">
        <div class="name"></div>
        <div class="issued">{{ $t('message.profile.borrower.activeOffers.items.issued') }}</div>
        <div class="amount">{{ $t('message.profile.borrower.activeOffers.items.amount') }}</div>
        <div class="term">{{ $t('message.profile.borrower.activeOffers.items.term') }}</div>
        <div class="percent">{{ $t('message.profile.borrower.activeOffers.items.percent') }}</div>
        <div class="income">{{ $t('message.profile.borrower.activeOffers.items.income') }}</div>
        <div class="issued-by">{{ $t('message.profile.borrower.activeOffers.items.issuedBy') }}</div>
        <div class="peni">{{ $t('message.profile.borrower.activeOffers.items.peni') }}</div>
        <div class="total-amount">{{ $t('message.profile.borrower.activeOffers.items.totalAmount') }}</div>
        <div class="status">{{ $t('message.profile.borrower.activeOffers.items.status') }}</div>
        <div class="pay"></div>
      </div>
      <div class="loans-desktop-container">
        <borrower-loan-item
          v-for="item of loansItems"
          :key="item.id"
          :item="item"
          @openPayModal="openPayModal"
        />
      </div>
      <div class="loans-mobile-container">
        <mobile-borrower-loan-item
          v-for="item of loansItems"
          :key="item.id"
          :item="item"
          @openPayModal="openPayModal"
        />
      </div>
      <div class="more-block">
        <div class="notice">* - без учёта комиссий</div>
        <div class="more-container" @click="showMoreLoans()" v-if="isHasMoreLoans">
          <span>
            {{ $t('message.profile.lender.activeOffers.moreOffers') }}
          </span>
          <img src="../../../public/custom/images/more-arrow-down.svg" alt="More arrow down">
        </div>
      </div>
    </div>
    <base-modal
      v-if="isPayModalVisible"
      @close="closePayModal()"
    >
      <template #header>
        <div class="modal-header">
          <img @click.stop="closePayModal()" class="close-image" src="../../../public/custom/images/cross.svg" alt="Cross image">
        </div>
        <div class="modal-title">
          {{ $t('message.profile.borrower.activeOffers.payModal.title') }}
        </div>
        <div class="pay-input-block">
          <base-payment-input
            class="pay-input"
            :placeholder="`${payment.totalAmount / 100} ${$t('message.profile.borrower.activeOffers.payModal.currency')}`"
            :name="'loanPayConfirmation'"
            :validateRules="validateRules"
            v-model="payment.amount"
            :disabled="isPayBtnLoading"
          />
        </div>
        <div class="btn-block">
          <base-button
            :text="$t('message.profile.borrower.activeOffers.payModal.payBtn')"
            :disabled="isPayBtnDisabled"
            :is-loading="isPayBtnLoading"
            @click="startPayment()"
          />
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import borrowerLoanItem from "./borrowerLoanItem.vue";
import BaseModal from "../../components/base/BaseModal.vue";
import BaseButton from "../../components/base/BaseButton.vue";
import BasePaymentInput from "../../components/base/BasePaymentInput.vue";
import MobileBorrowerLoanItem from "./mobileBorrowerLoanItem.vue";

export default {
  name: "BorrowerProfile",
  inject: ['$httpService'],
  components: {
    borrowerLoanItem,
    BaseModal,
    BaseButton,
    BasePaymentInput,
    MobileBorrowerLoanItem
  },
  created() {
    this.loansItems = [...this.loansList]
  },
  data() {
    return {
      isPayModalVisible: false,
      payment: {
        totalAmount: 0,
        amount: '',
        loan_public_id: ''
      },
      isPayBtnLoading: false,
      pageParams: {
        page: 0,
        size: 10
      },
      loansItems: []
    }
  },
  methods: {
    async showMoreLoans() {
      this.pageParams.page = this.pageParams.page + 1;

      await this.$store.dispatch("getLoansList", {...this.pageParams});
      this.loansItems = [...this.loansItems, ...this.loansList];
    },
    openPayModal(data) {
      this.payment = {...this.payment, ...data};
      this.isPayModalVisible = true;
    },
    closePayModal() {
      if (!this.isPayBtnLoading) {
        this.isPayModalVisible = false;
      }
    },
    async startPayment() {
      this.isPayBtnLoading = true;
      const fixedAmount = (parseFloat(this.payment.amount).toFixed(2));
      const amount = (fixedAmount * 100).toFixed(0);
      const loan_public_id = this.payment.loan_public_id;

      try {
        const response = await this.$httpService.loan.loanPayment({ amount, loan_public_id });

        this.isPayBtnLoading = false;
        this.closePayModal();
        this.$emit('successPayment', response.data);
      } catch (error) {
        this.isPayBtnLoading = false;
        this.closePayModal();
      }
    }
  },
  computed: {
    ...mapGetters(["profile", "loansList", 'isHasMoreLoans']),
    userLocality() {
      return `${this.profile.address.locality}, ${this.profile.address.country}`;
    },
    isBorrowerLoansListEmpty() {
      return this.loansItems.length === 0;
    },
    validateRules() {
      return `loanPayConfirmation:${this.payment.totalAmount}`
    },
    isPayBtnDisabled() {
      return this.errors.items.length > 0 || !this.payment.amount || this.payment.amount === '0' || this.isPayBtnLoading;
    }
  },
};
</script>

<style lang="scss" scoped>
.borrower-container {
  @include base-page-container;

  flex-direction: column;
  color: #121212;
}

.user-info-container {
  margin-bottom: 60px;
  display: flex;
  flex-direction: column;
}

.user-info {
  margin-bottom: 20px;
  display: flex;
  align-items: flex-end;
}

.user-name {
  margin-right: 68px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 26px;
  line-height: 32px;
  display: flex;
  align-items: center;
  letter-spacing: 0.01em;
  color: #000000;
}

.user-location,
.user-role {
  margin-bottom: 12px;
  font-weight: 400;
  font-size: 18px;
  color: #181a1b;
}

.user-role {
  margin-bottom: 0;
  display: flex;
  align-items: flex-end;
}

.role {
  font-weight: 700;
  font-size: 20px;
  color: #181a1b;
}

.rate-block {
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  span {
    margin-top: 3px;
    margin-right: 5px;
    font-weight: 400;
    font-size: 16px;
    line-height: 135%;
    color: var(--profile-rate-text-color);
  }
}

.no-rate-block {
  display: flex;
  align-items: center;

  img {
    margin-right: 7px;
    width: 24px;
    height: 24px;
  }

  span {
    font-weight: 400;
    font-size: 18px;
    line-height: 135%;
    color: #EB5757;
  }
}

.rate {
  font-weight: 600;
  font-size: 24px;
  line-height: 130%;
  color: #41bf7b;
}

.no-card-container,
.no-scoring-agreement {
  margin-bottom: 60px;
  padding: 30px;
  box-sizing: border-box;
  width: fit-content;
  background: #F8F8F8;
  border: 1px solid #F49332;
  border-radius: 20px;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.01em;
  color: #101010;
}

.no-card-link {
  color: #41BF7B;
}

.active-offers-container {
  @include active-offers-container;
  @include loan-item-header;
}

.active-offers-title {
  @include active-offers-title;
}

.modal-header {
  @include modal-close-block;
}

.close-image {
  cursor: pointer;
}

.modal-title {
  margin-bottom: 20px;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.01em;
  color: #101010;
}

.pay-input-block {
  margin-bottom: 30px;
  width: 275px;
  height: 60px;
}

.pay-input ::v-deep {
  input,
  input::placeholder {
    text-align: center;
  }
}

.btn-block {
  margin-bottom: 35px;
  width: 275px;
  height: 60px;
}

.user-status {
  width: fit-content;
  margin-bottom: 10px;
  padding: 5.5px 15px;
  box-sizing: border-box;
  border-radius: 6px;
}

.active-profile {
  color: #21A15C;
  background: #D6F9D3;
}

.inactive-profile,
.waiting-profile {
  color: #CB7723;
  background: #FFF1D5;
}

.blocked-profile {
  color: #c93434;
  background: #ffdbdb;
}

.more-block {
  margin-top: 15px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.notice {
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: #333333;
  }

.more-container {
  width: fit-content;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  cursor: pointer;

  img {
    margin-left: 5px;
  }
}

.route-name {
  @include route-name;
}

.loans-desktop-container {
  display: flex;
  flex-direction: column;
}

.loans-mobile-container {
  display: none;
  flex-direction: column;
}

@media screen and (max-width: 850px) {
  .active-offers-container .offers-item-header {
    display: none;
  }

  .loans-desktop-container {
    display: none;
  }

  .loans-mobile-container {
    display: flex;
  }
}
</style>
